var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgFacebookDark = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 76 76"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M38 0C17.012 0 0 17.012 0 38c0 18.752 13.586 34.32 31.445 37.426v-.131h.002V48.484h-9.17V37.998h9.17v-8.37c0-9.523 6.287-15.213 14.97-15.213 4.157 0 8.617.683 8.617.683v9.799h-4.905c-4.72 0-5.577 2.971-5.577 5.976v7.125h10.482l-1.833 10.486h-8.649v26.942C62.414 72.32 76 56.752 76 38 76 17.012 58.987 0 38 0"
})));
export { SvgFacebookDark as ReactComponent };
export default __webpack_public_path__ + "static/media/facebookDark.eadaeb2e.svg";